const backPath = ({ groupId }) =>
  `/management_panel/groups_management/${groupId}/announcements`

export { backPath }
